module.exports = __webpack_public_path__ + "img/idCard1.35068dfa.png";